import "regenerator-runtime/runtime";
import "bootstrap/dist/css/bootstrap.min.css";

const form = document.querySelector("form");
const cryptoSelect = document.querySelector(".crypto");
const currencySelect = document.querySelector(".currency");
const cryptoInputAmount = document.querySelector(".exchangeAmount");
const result = document.querySelector(".result");

form.addEventListener("submit", (event) => {
  event.preventDefault();

  async function getData() {
    // fetching data
    const response = await fetch(
      `https://api.cryptonator.com/api/ticker/${cryptoSelect.value}-${currencySelect.value}`
    );
    const data = await response.json();
    const rate = +data.ticker.price;

    // calculate price
    result.value = (cryptoInputAmount.value * rate).toFixed(2);
  }

  getData();
});
